import { render, staticRenderFns } from "./ResultBlock.vue?vue&type=template&id=78270b36&scoped=true"
import script from "./ResultBlock.vue?vue&type=script&lang=js"
export * from "./ResultBlock.vue?vue&type=script&lang=js"
import style0 from "./ResultBlock.vue?vue&type=style&index=0&id=78270b36&prod&lang=scss&scoped=true"
import style1 from "./ResultBlock.vue?vue&type=style&index=1&id=78270b36&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78270b36",
  null
  
)

export default component.exports